module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis4-57389e41b93edf2409f9dadb5fb2cd30.jpg";